import { Domain } from "@/types/domain";
import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export class DomainHttp extends Vue {
	public getDomains(): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/domain", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public deleteDomain(domainToDelete: Domain): Promise<AxiosResponse<any>> {
		return axios.delete(
			process.env.VUE_APP_API_ENDPOINT + "/domain/deleteById/" + domainToDelete.id,
			{
				headers: {
					authorization: "Bearer " + localStorage.getItem("access_token"),
				},
			}
		);
	}

	public postDomain(domainToPost: any): Promise<AxiosResponse<any>> {
		return axios.post(process.env.VUE_APP_API_ENDPOINT + "/domain", domainToPost, {
			headers: {
				"Content-Type": "application/json",
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}

	public getDomainById(id: string): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/domain/" + id, {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}
}
